import { api } from "../api";

/**
 * findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse - Function that finds on database all vehicles as select list response   
 * /vehicles/list/{customerId}/{secretaryId}/{departmentId}  
 * method GET 
 * @async-function
 */
const findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse = async (token: string, customerId: number, departmentId: number, ignoreDepartments: boolean = false, status: string = "activated") => {
    const response = await api.get(
        `/vehicles/list/${customerId}/${departmentId}/${status}?ignoreDepartments=${ignoreDepartments}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response;
};
export default findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse;